import type { TechniqueEntry } from '../schema';

export const doubleSidedReflection: TechniqueEntry = {
  key: 'double_sided_reflection',
  version: '0.1',
  name: 'Double-sided reflection',
  pillar: 'MI',
  serves:
    "Naming a member's ambivalence plainly and leaving it open, when both the reason to keep the behaviour and the reason it bothers them are present in the room.",
  method: [
    'Elicit their own appraisal first, held completely without judgment: ask openly how they see their use these days, how it sits with them when they step back.',
    "When both sides are present, name them in one balanced reflection, both halves in the member's own language: their reason to keep it and their reason it bothers them, held side by side as equally real, no verdict attached.",
    'Compose the reflection fresh from their words each time: the two-sided shape is the technique; the sentence is theirs. Then leave it open: naming the ambivalence clearly is the outcome.',
  ],
  never: [
    'Do not resolve the ambivalence.',
    'Do not move to planning.',
    {
      constraint: 'Never use this banned reflective hedge (or any other).',
      phrase: 'it sounds like',
    },
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: "Both sides of the ambivalence are in the room, in the member's own words.",
    },
  ],
  doneWhen:
    "The ambivalence named plainly in the member's language and left with them: they hear both halves held together without a verdict.",
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source: 'shared/sections/practice_objective.md (Movement D), base doc catalogue table',
};
